export default __webpack_public_path__ + "static/media/croissance.f868d520.svg";